import React from "react";

const AttractiveEmptyState = ({
  icon: Icon,
  title = "No events today",
  description = "Your schedule is clear for today.",
  actionButton = null,
}) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8 tw-px-4 tw-text-center">
      {/* Visual Graphic Container */}
      <div className="tw-relative tw-mb-4 tw-flex tw-items-center tw-justify-center">
        {/* Soft Ambient Glow */}
        <div className="tw-absolute -tw-inset-2 tw-rounded-full tw-bg-gradient-to-tr tw-from-[#5d44ff]/20 tw-via-indigo-200/40 tw-to-purple-100/50 tw-blur-md" />
        
        {/* Glassmorphic Outer Card */}
        <div className="tw-relative tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-rounded-3xl tw-bg-white/90 tw-backdrop-blur-md tw-border tw-border-solid tw-border-indigo-100 tw-shadow-[0_8px_25px_rgba(93,68,255,0.1)]">
          {/* Gradient Icon Badge */}
          <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-gradient-to-br tw-from-[#5d44ff] tw-to-indigo-600 tw-text-white tw-shadow-[0_4px_14px_rgba(93,68,255,0.3)]">
            {Icon && <Icon size={26} className="tw-stroke-[2]" />}
          </div>
        </div>

        {/* Decorative Accent Dots */}
        <div className="tw-absolute -tw-top-1 -tw-right-1 tw-h-3 tw-w-3 tw-rounded-full tw-bg-amber-400 tw-shadow-sm" />
        <div className="tw-absolute -tw-bottom-1 -tw-left-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-indigo-300" />
      </div>

      {/* Title & Subtitle */}
      <h4 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-mb-1 tw-tracking-tight">
        {title}
      </h4>
      {description && (
        <p className="tw-text-xs tw-font-medium tw-text-slate-400 tw-max-w-[220px] tw-mb-0 tw-leading-relaxed">
          {description}
        </p>
      )}

      {actionButton && <div className="tw-mt-4">{actionButton}</div>}
    </div>
  );
};

export default AttractiveEmptyState;
